import {IImportService} from "./IImportService";
import {Asset} from "../entities/Asset";
import {BaseService} from "./BaseService";
import { StateService } from "@uirouter/angularjs";
import { ImportField } from "../models/import/ImportField";
import { ImportError } from "../models/import/ImportError";
import { ImportColumn } from "../models/import/ImportColumn";
import { ServerImportField } from "../models/serverimport/ServerImportField";

export class AssetService extends BaseService<Asset> implements IImportService<Asset>{
    static $inject = ['$http', '$q', '$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, Asset);
    }
    protected getBaseUrl(): string {
        return "asset";
    }
    updateCheckin(assetId: number, locationId: number, checkinStatus: string, checkedOutTo: string) {
        var config: any = {};
        return this.usePutHandler(this.getBaseUrl(), "checkin?assetID=" + assetId + "&locationId="+locationId+"&checkinStatus=" + checkinStatus + "&checkedOutTo=" + checkedOutTo, config);
    }
    updateLocation(assetId: number, locationId: number, changePrimaryLocation: boolean) {
        var config: any = {};
        return this.usePutHandler(this.getBaseUrl(), "location?assetID=" + assetId + "&locationId=" + locationId + "&changePrimaryLocation=" + changePrimaryLocation, config);
    }
    getMaintenanceReport(search: string, locationName:string, locationSite:string, startDate: string, endDate: string) {
        var config: any = {
            headers: {
                'Content-type': 'application/json',
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'arraybuffer'
        };
        return this.useGetHandler("Report", "ScheduledMaintenance?search=" + name + "&locationName=" + locationName + "&locationSite=" + locationSite + "&startDate=" + startDate + "&endDate=" + endDate, config);
    }
    getByMaintenance(search: string, locationName: string, locationSite: string, startDate: string, endDate: string): ng.IPromise<Asset[]> {
        var config: any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(), "maintenance?search=" + search + "&locationName=" + locationName + "&locationSite=" + locationSite + "&startDate=" + startDate + "&endDate=" + endDate, config);
    }
    getByMaintenanceCount(search: string, locationName:string, locationSite:string, startDate: string, endDate: string): ng.IPromise<number> {
        var config: any = {};
        return this.useGetHandler(this.getBasesUrl(), "maintenanceCount?search=" + search + "&locationName=" + locationName + "&locationSite=" + locationSite + "&startDate=" + startDate + "&endDate=" + endDate, config);
    }
    getByName(name: string): ng.IPromise<Asset> {
        var config: any = {};
        // Modified 022519 by BA to put name as a query parameter to handle special characters (# and %)
        return this.useBaseGetHandler(this.getBaseUrl(), "name?name=" + encodeURIComponent(name), config);
    }
    getByVTag(tagId: string): ng.IPromise<Asset> {
        var config: any = {};
        return this.useBaseGetHandler(this.getBaseUrl(), "vtag/" + tagId, config);
    }
    getCurrentAssetNameSerial(): ng.IPromise<string> {
        var config: any = {};
        return this.useGetHandler(this.getBaseUrl(), "currentAssetNameSerial", config);
    }
    getByRfid(tagId: string): ng.IPromise<Asset> {
        var config: any = {};
        return this.useBaseGetHandler(this.getBaseUrl(), "rfidtag/" + tagId, config);
    }
    getByGps(tagId: string): ng.IPromise<Asset> {
        var config: any = {};
        return this.useBaseGetHandler(this.getBaseUrl(), "VTagGPS/" + tagId, config);
    }
    batchMove(ids: number[], locationId: number): ng.IPromise<void> {
        return this.usePutHandler(this.getBasesUrl(), "move?locationId=" + locationId, ids);
    }
    getFixedChildren(vtagId: string): ng.IPromise<Asset[]> {
        return this.useBaseGetArrayHandler("assetvtags", "nearestToFixed/" + vtagId, {});
    }
    // Modified 03/27/20 by BA to include GPS
    getFirstVTagAndGpsMatch(search: string): ng.IPromise<Asset> {
        var config: any = {};
        return this.useBaseGetHandler("assetvtag", "firstVTagMatch?search=" + search, config);
    }
    // Modified 03/27/20 by BA to include GPS
    getVTagAndGpsAssetsBySite(mapSiteId: number): ng.IPromise<Asset[]> {
        return this.useBaseGetArrayHandler("assetvtags", "site?siteId=" + mapSiteId, {});
    }
    getBatteryLevelReport(count: number) {
        var config: any = {
            headers: {
                'Content-type': 'application/json',
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'arraybuffer'
        };
        return this.useGetHandler("Report", "BatteryLevels?count=" + count, config);
    }
    getBatteryLevels(count: number) {
        var config: any = {};
        return this.useGetHandler("assetvtags", "BatteryLevels?count=" + count, config);
    }
    // Modified 03/27/20 by BA to include GPS
    getChangedVTagAndGpsAssetsBySite(mapSiteId: number, lastChecked: string): ng.IPromise<Asset[]> {
        var config: any = {};
        return this.useBaseGetArrayHandler("assetvtags", "changed?siteId=" + mapSiteId + "&lastChecked=" + lastChecked, config);
    }
    getReportCount(name: string, location: string, locationSite: string, tagType: string, assetType: string, department: string, disposalStatus: string, checkinStatus: string, missing: string): ng.IPromise<number> {
        var config: any = {};
        return this.useGetHandler(this.getBasesUrl(), "ReportCount?name=" + name + "&location=" + location + "&locationSite=" + locationSite + "&tagType=" + tagType + "&assetType=" + assetType + "&department=" + department + "&disposalStatus="
            + disposalStatus + "&checkinStatus=" + checkinStatus + "&missing=" + missing, config);
    }
    getAssetChildrenReportCount(name: string): ng.IPromise<number> {
        var config: any = {};
        return this.useGetHandler(this.getBasesUrl(), "AssetChildrenReportCount?name=" + name, config);
    }
    getReport(name: string, location: string, locationSite: string, tagType: string, assetType: string, department: string, disposalStatus: string, checkinStatus: string, missing: string) {
        var config: any = {
            headers: {
                'Content-type': 'application/json',
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'arraybuffer'
        };
        var timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return this.useGetHandler("Report", "Assets?timeZoneId=" + timeZoneId + "&name=" + name + "&location=" + location + "&locationSite=" + locationSite + "&tagType=" + tagType + "&assetType=" + assetType + "&department=" + department + "&disposalStatus="
            + disposalStatus + "&checkinStatus=" + checkinStatus + "&missing=" + missing, config);
    }
    getAssetChildrenReport(name: string) {
        var config: any = {
            headers: {
                'Content-type': 'application/json',
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'arraybuffer'
        };
        return this.useGetHandler("Report", "AssetChildren?&name=" + name, config);
    }
    getReportItems(name: string, location: string, assetType: string, department: string, disposalStatus: string, checkinStatus: string, missing: string): ng.IPromise<Asset[]> {
        var config: any = {};
        //TODO: work on this. not implemented
        return this.useBaseGetArrayHandler(this.getBasesUrl(), "Report?name=" + name + "&location=" + location + "&assetType=" + assetType + "&department=" + department + "&disposalStatus="
            + disposalStatus + "&checkinStatus=" + checkinStatus + "&missing=" + missing, config);
    }
    getMaintenanceReportCount(name: string, location: string, assetType: string, department: string, disposalStatus: string, checkinStatus: string, missing: string): ng.IPromise<number> {
        var config: any = {};
        //TODO: work on this. not implemented
        return this.useGetHandler(this.getBasesUrl(), "getMaintenanceReportCount?name=" + name + "&location=" + location + "&assetType=" + assetType + "&department=" + department + "&disposalStatus="
            + disposalStatus + "&checkinStatus=" + checkinStatus + "&missing=" + missing, config);
    }
    getMaintenanceReportItems(name: string, location: string, assetType: string, department: string, disposalStatus: string, checkinStatus: string, missing: string): ng.IPromise<Asset[]> {
        var config: any = {};
        //TODO: work on this. not implemented
        return this.useBaseGetArrayHandler(this.getBasesUrl(), "getMaintfgenanceReportItems?name=" + name + "&location=" + location + "&assetType=" + assetType + "&department=" + department + "&disposalStatus="
            + disposalStatus + "&checkinStatus=" + checkinStatus + "&missing=" + missing, config);
    }
    getImportFields(): ng.IPromise<any> {
        var config: any = {};
        //TODO: work on this. not implemented
        return this.useGetHandler(this.getBasesUrl(), "importFields", config);
    }
    getImportColumns(fileId: string): ng.IPromise<ImportColumn[]> {
        var config: any = {};
        //TODO: work on this. not implemented
        return this.useGetHandler(this.getBasesUrl(), "ImportColumns?fileId=" + fileId, config);
    }
    importFile(fileId: string, importFields: ServerImportField[], test: boolean): ng.IPromise<boolean> {
        return this.usePostHandler(this.getBasesUrl(), 'serverImport?fileId=' + fileId + '&test=' + test, importFields);
    }
    importFileProgress(fileId: string): ng.IPromise<number> {
        return this.useGetHandler(this.getBasesUrl(), "serverimportprogress?fileId=" + fileId, {});
    }
    importResults(fileId: string): ng.IPromise<ImportError[]> {
        return this.useGetHandler(this.getBasesUrl(), "serverimportresults?fileId=" + fileId, {});
    }
    import(entities:Asset[],test:boolean):ng.IPromise<string[]>{
        return this.usePostHandler(this.getBasesUrl(),"import?test="+test, entities);
    }
    clearAllRtlsInformation():ng.IPromise<any>{
        var config:any = {};
        return this.useDeleteHandler("assetvtags","rtlsInformation", config);
    }
    associateChildren(assetIds:number[], parentId:number):ng.IPromise<void>{
        return this.usePutHandler(this.getBasesUrl(),"children?parentID="+parentId, assetIds);
    }
    removeChildren(assetIds:number[]):ng.IPromise<void>{
        var assetIdString = "assetIds="+assetIds[0];
        for(var i=1;i<assetIds.length; i++){
            assetIdString += "&assetIds="+assetIds[i];
        }
        return this.useDeleteHandler(this.getBasesUrl(),"children?"+assetIdString, {});
    }
    getCountUsableChildren(parentID:number,search:string):ng.IPromise<number>{
        var config:any = {};
        var strParentID:string = parentID == null ? "" : parentID+"";
        return this.useGetHandler(this.getBasesUrl(),"countUsableChildren?parentID="+strParentID+"&search="+search, config);
    }
    getPagedUsableChildren(parentID:number,search:string,page:number,pageSize:number,orderColumn:string,orderDirection:string):ng.IPromise<Asset[]>{
        var config:any = {};
        var strParentID:string = parentID == null ? "" : parentID+"";
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"pagedUsableChildren?parentID="+strParentID+"&search="+search+"&page="+page+"&pageSize="+pageSize+"&orderColumn="+orderColumn+"&orderDirection="+orderDirection, config);
    }
    // Modified 03/27/20 by BA to include GPS
    getVTagAndGpsAssetsCount(search:string):ng.IPromise<number>{
        var config:any = {};
        return this.useGetHandler("assetvtags","count?search="+search, config);
    }
    // Modified 03/27/20 by BA to include GPS
    getVTagAndGpsAssetsPaged(search:string,page:number,pageSize:number,orderColumn:string,orderDirection:string):ng.IPromise<Asset[]>{
        var config:any = {};
        return this.useBaseGetArrayHandler("assetvtags","paged?search="+search+"&page="+page+"&pageSize="+pageSize+"&orderColumn="+orderColumn+"&orderDirection="+orderDirection, config);
    }
    getChildren(assetId:number):ng.IPromise<Asset[]>{
        return this.useBaseGetArrayHandler("assets","children/"+assetId, {});
    }
}
